/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const baseChallengeClipBodySchema = z.object({
  durationMs: z.number().int().positive(),
  sortOrder: z.number().int().optional(),
  transcript: z.string().nullable().optional(),
  published: z.number().int().min(0).max(1).optional(),
  basePath: z.string().nullable().optional(),
  verticalPath: z.string().nullable().optional(),
});

export type IBaseChallengeClipBody = z.infer<typeof baseChallengeClipBodySchema>;
